export function canEditResource(resource) {
  return resource?.can_edit !== false
}
